//import Uiconstants from "../../lib/UIconstants"
import CloseController from '../../controllers/CloseController';
import { SettigsItem } from './SettingsItem';
import SettigsItemController from '../../controllers/settings/SettigsItemController';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { SettingsViewGrid } from './SettingsViewGrid';
import SettingsPageController from '../../controllers/settings/SettingsPageController';

export const SettigsView = {
	name: COMPONENTS.SETTINGS_PAGE,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 0,
				item: 'background_music_holder',
				val: 'background_music',
				texts: [
					'SETTINGS_ITEM_INFO_SFX',
					'SETTINGS_ITEM_TITLE_SFX_BG',
					'SETTINGS_ITEM_DESC_SFX_BG'
				],
				active: GameConfigs.settings.background_music,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 1,
				item: 'fast_spin_holder',
				val: 'fast_spin',
				texts: [
					'SETTINGS_ITEM_INFO_FUNC',
					'SETTINGS_ITEM_TITLE_FUNC_RS',
					'SETTINGS_ITEM_DESC_FUNC_RS'
				],
				active: GameConfigs.settings.fast_spin,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 2,
				item: 'keyboard_shortcuts_holder',
				val: 'keyboard_shortcuts',
				texts: [
					'SETTINGS_ITEM_INFO_FUNC',
					'SETTINGS_ITEM_TITLE_VISUAL_KS',
					'SETTINGS_ITEM_DESC_VISUAL_KS'
				],
				active: GameConfigs.settings.keyboard_shortcuts,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 3,
				item: 'sound_effects_holder',
				val: 'sound_effects',
				texts: [
					'SETTINGS_ITEM_INFO_SFX',
					'SETTINGS_ITEM_TITLE_SFX_SE',
					'SETTINGS_ITEM_DESC_SFX_SE'
				],
				active: GameConfigs.settings.sound_effects,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 4,
				item: 'game_animation_holder',
				val: 'game_animation',
				texts: [
					'SETTINGS_ITEM_INFO_FUNC',
					'SETTINGS_ITEM_TITLE_FUNC_GA',
					'SETTINGS_ITEM_DESC_FUNC_GA'
				],
				active: GameConfigs.settings.game_animation,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 5,
				item: 'splash_screen_holder',
				val: 'splash_screen',
				texts: [
					'SETTINGS_ITEM_INFO_VISUAL',
					'SETTINGS_ITEM_TITLE_FUNC_SS',
					'SETTINGS_ITEM_DESC_SS_DESC'
				],
				active: GameConfigs.settings.splash_screen,
				color: '#864F5C',
				holder: 'settings_view_holder_up'
			}
		},
		{
			Controller: MainGridController,
			name: 'SettingsViewGrid',
			config: SettingsViewGrid
		},
		{
			Controller: SettingsPageController,
			name: 'SettingsPageController',
			config: {
				holder: 'settings_view_holder_up'
			}
		}
	],
	components: [
		{
			name: 'settings_view_holder_up',
			type: 'Sprite',
			components: [
				{
					name: 'reel_bg',
					type: 'Sprite',
					img: 'reel_bg'
				},
				{
					name: 'reel_bg_border',
					type: 'Sprite',
					img: 'reel_border',
					position: { x: 0, y: -5 }
				},
				{
					name: 'header',
					type: 'Text',
					position: { x: 1144 / 2, y: 30 },
					text: 'SETTINGS_PAGE_HEADER',
					anchor: {
						x: 0.5,
						y: 0
					}
				},
				{
					name: 'close',
					type: 'SimpleButton',
					position: { x: 1050, y: 30 },
					components: [
						{
							name: 'xxxxx',
							type: 'MouseOverSprite',
							img: 'close_icon',
							imgHover: 'close_icon_hovered'
						}
					]
				},
				{
					name: 'background_music_holder',
					type: 'Sprite',
					components: [
						{
							name: 'background_music',
							position: { x: 43, y: 116 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				},
				{
					name: 'fast_spin_holder',
					type: 'Sprite',
					components: [
						{
							name: 'fast_spin',
							position: { x: 43, y: 292 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				},
				{
					name: 'keyboard_shortcuts_holder',
					type: 'Sprite',
					components: [
						{
							name: 'keyboard_shortcuts',
							position: { x: 43, y: 468 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				},
				{
					name: 'sound_effects_holder',
					type: 'Sprite',
					components: [
						{
							name: 'sound_effects',
							position: { x: 580, y: 116 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				},
				{
					name: 'game_animation_holder',
					type: 'Sprite',
					components: [
						{
							name: 'game_animation',
							position: { x: 580, y: 292 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				},
				{
					name: 'splash_screen_holder',
					type: 'Sprite',
					components: [
						{
							name: 'splash_screen',
							position: { x: 580, y: 468 },
							type: 'VisualComponent',
							component: SettigsItem
						}
					]
				}
			]
		}
	]
};
